import {useTranslation} from 'react-i18next';
import css from './pages.module.css';
import {ChatPanel} from '../components/note/ChatPanel';
import askaiOwl from '../assets/askai_owl.png';

// Mobile WelcomeMessage quick-action chips (same i18n keys).
const QUICK_KEYS = [
  'QuickRecentNotes',
  'QuickLastNote',
  'QuickLastWeek',
  'QuickActionItems',
  'QuickQuizNote',
  'QuickNoteStats',
];

export function AskAiPage() {
  const {t} = useTranslation();
  return (
    <div className={css.page}>
      <header className={css.pageHeader}>
        <h1 className={css.pageTitle}>{t('AskAI')}</h1>
      </header>
      <ChatPanel
        noteId={null}
        suggestions={QUICK_KEYS.map(key => t(key))}
        emptyState={
          <div className={css.aiHero}>
            <div className={css.heroGlow}>
              <img src={askaiOwl} alt="" style={{width: 104}} />
            </div>
            <h2 className={css.aiHeroTitle}>{t('AskOwllyAnything')}</h2>
            <p className={css.aiHeroSub}>{t('AskAnythingHint')}</p>
          </div>
        }
      />
    </div>
  );
}
